// placeholder for platform translations
export const biometry = {};
